import { distributionListPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { RecommendationDistribution } from '@/common/model/recommend/recommendationDistribution'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main from '@/components/view/layouts/page/Main'

import RecommendationDistributionForm from '@/components/container/form/modules/recommend/distribution/RecommendationDistributionForm'

interface Props {
  distribution?: RecommendationDistribution
  onRefetch?: () => void
}

const RecommendationDistributionEditPage = ({ distribution, onRefetch }: Props) => {
  const siteId = useSiteId()
  return (
    <Main>
      <BackButton link={distributionListPath(siteId)} />
      <RecommendationDistributionForm distribution={distribution} onRefetch={onRefetch} />
    </Main>
  )
}

export default RecommendationDistributionEditPage
